<div class="vt-details a-section" *ngIf="data">
  <div class="vt-details__item is-header">
    <div>{{ 'VacancyTalentDetails.Skills' | translate }}</div>
    <div>{{ 'VacancyTalentDetails.Vacancy' | translate }}</div>
    <div>{{ 'VacancyTalentDetails.TalentExpectations' | translate }}</div>
  </div>

  <!-- Salary -->
  <div class="vt-details__item"
    *ngIf="data.salaryMatch?.talent?.amount
    || data.salaryMatch?.vacancy?.amount
    || data.salaryMatch?.vacancy?.amountTo">
    <div>
      <i class="app-ico-mask app-ico-mask__salary"></i>{{ 'VacancyTalentDetails.Salary' | translate }}
    </div>
    <div>
      <ng-container *ngIf="data.salaryMatch.vacancy.amount || data.salaryMatch.vacancy.amountTo">
        {{ data.salaryMatch.vacancy.currency | currency }}
        {{ data.salaryMatch.vacancy.amount | salaryDivider }} 
        <span *ngIf="data.salaryMatch.vacancy.amount && data.salaryMatch.vacancy.amountTo">- </span> 
        <ng-container *ngIf="data.salaryMatch.vacancy.amountTo">{{data.salaryMatch.vacancy.amountTo | salaryDivider }}</ng-container>
        {{ data.salaryMatch.vacancy.period | salaryPeriod }}
      </ng-container>
      <ng-container *ngIf="!data.salaryMatch.vacancy.amount && !data.salaryMatch.vacancy.amountTo">Not specified</ng-container>
    </div>
    <div [class.is-red]="matchRed.salaryMatch">
      <ng-container *ngIf="data.salaryMatch.talent.amount">
        {{ data.salaryMatch.talent.currency | currency }} 
        {{ data.salaryMatch.talent.amount | salaryDivider }} 
        {{ data.salaryMatch.talent.period | salaryPeriod }}
      </ng-container>
      <ng-container *ngIf="!data.salaryMatch.talent.amount">Not specified</ng-container>
    </div>
  </div>

  <!-- Relocation -->
  <div class="vt-details__item"
    *ngIf="data.relocationMatch.vacancy !== null || data.relocationMatch.talent !== null">
    <div>
      <i class="app-ico-mask app-ico-mask__relocation"></i>{{ 'VacancyTalentDetails.Relocation' | translate }}
    </div>
    <div>
      <ng-container *ngIf="data.relocationMatch.vacancy !== null">
        {{data.relocationMatch.vacancy | relocation }}
      </ng-container>
      <ng-container *ngIf="data.relocationMatch.vacancy === null">Not specified</ng-container>
    </div>
    <div [class.is-red]="matchRed.relocationMatch">
      <ng-container *ngIf="data.relocationMatch.talent !== null">
        {{data.relocationMatch.talent | relocation }}
      </ng-container>
      <ng-container *ngIf="data.relocationMatch.talent === null">Not specified</ng-container>
    </div>
  </div>

  <!-- Company domain -->
  <div class="vt-details__item"
    *ngIf="(data.domainMatch.vacancy && data.domainMatch.vacancy.length) || (data.domainMatch.talent && data.domainMatch.talent.length)">
    <div>
      <i class="app-ico-mask app-ico-mask__domain"></i>{{ 'VacancyTalentDetails.CompanyDomain' | translate }}
    </div>
    <div>
      <ng-container *ngIf="data.domainMatch.vacancy && data.domainMatch.vacancy.length">
        <div *ngFor="let domain of data.domainMatch.vacancy" [innerHTML]="domain"></div>
      </ng-container>
      <ng-container *ngIf="!data.domainMatch.vacancy || !data.domainMatch.vacancy.length">Not specified</ng-container>
    </div>
    <div [class.is-red]="matchRed.domainMatch">
      <ng-container *ngIf="data.domainMatch.talent && data.domainMatch.talent.length">
        <div *ngFor="let domain of data.domainMatch.talent" [innerHTML]="domain"></div>
      </ng-container>
      <ng-container *ngIf="!data.domainMatch.talent || !data.domainMatch.talent.length">Not specified</ng-container>
    </div>
  </div>

  <!-- Language -->
  <div class="vt-details__item"
    *ngIf="(data.languageMatch.vacancy && data.languageMatch.vacancy.length) || (data.languageMatch.talent && data.languageMatch.talent.length)">
    <div>
      <i class="app-ico-mask app-ico-mask__language"></i>{{ 'VacancyTalentDetails.Language' | translate }}
    </div>
    <div>
      <ng-container *ngIf="data.languageMatch.vacancy && data.languageMatch.vacancy.length">
        <div *ngFor="let lang of data.languageMatch.vacancy">
          {{ lang.name }}<span class="left-m" *ngIf="lang.level">({{ lang.level }})</span>
        </div>
      </ng-container>
      <ng-container *ngIf="!data.languageMatch.vacancy || !data.languageMatch.vacancy.length">Not specified</ng-container>
    </div>
    <div>
      <ng-container *ngIf="data.languageMatch.talent && data.languageMatch.talent.length">
        <div *ngFor="let lang of data.languageMatch.talent">
          {{ lang.name }}<span class="left-m" *ngIf="lang.level">({{ lang.level }})</span>
        </div>
      </ng-container>
      <ng-container *ngIf="!data.languageMatch.talent || !data.languageMatch.talent.length">Not specified</ng-container>
    </div>
  </div>

  <!-- Employment type -->
  <div class="vt-details__item"
    *ngIf="data.employmentTypeMatch.vacancy || data.employmentTypeMatch.talent">
    <div>
      <i class="app-ico-mask app-ico-mask__employment-type"></i>    {{ 'VacancyTalentDetails.EmploymentType' | translate }}
    </div>
    <div>
      <ng-container *ngIf="data.employmentTypeMatch.vacancy">
        {{ data.employmentTypeMatch.vacancy | employmentType }}
      </ng-container>
      <ng-container *ngIf="!data.employmentTypeMatch.vacancy">Not specified</ng-container>
    </div>
    <div [class.is-red]="matchRed.employmentTypeMatch">
      <ng-container *ngIf="data.employmentTypeMatch.talent">
        {{ data.employmentTypeMatch.talent | employmentType }}
      </ng-container>
      <ng-container *ngIf="!data.employmentTypeMatch.talent">Not specified</ng-container>
    </div>
  </div>

  <!-- Education -->
  <div class="vt-details__item"
    *ngIf="data.educationMatch.vacancy.educationDegree || data.educationMatch.vacancy.educationField
    || data.educationMatch.talent.educationDegree || data.educationMatch.talent.educationField">
    <div>
      <i class="app-ico-mask app-ico-mask__education"></i>{{ 'VacancyTalentDetails.Education' | translate }}
    </div>
    <div>
      <ng-container *ngIf="data.educationMatch.vacancy.educationDegree || data.educationMatch.vacancy.educationField">
        <ng-container *ngIf="data.educationMatch.vacancy.educationDegree">
          {{ data.educationMatch.vacancy.educationDegree }}
        </ng-container>
        <ng-container *ngIf="data.educationMatch.vacancy.educationField">
          {{ data.educationMatch.vacancy.educationField }}
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!data.educationMatch.vacancy.educationDegree && !data.educationMatch.vacancy.educationField">Not specified</ng-container>
    </div>
    <div [class.is-red]="matchRed.educationMatch">
      <ng-container *ngIf="data.educationMatch.talent.educationDegree || data.educationMatch.talent.educationField">
        <ng-container *ngIf="data.educationMatch.talent.educationDegree">
          {{ data.educationMatch.talent.educationDegree }}
        </ng-container>
        <ng-container *ngIf="data.educationMatch.talent.educationField">
          {{ data.educationMatch.talent.educationField }}
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!data.educationMatch.talent.educationDegree && !data.educationMatch.talent.educationField">Not specified</ng-container>
    </div>
  </div>

  <!-- Workplace -->
  <div class="vt-details__item"
    *ngIf="data.workPlaceMatch.vacancy || data.workPlaceMatch.talent">
    <div>
      <i class="app-ico-mask app-ico-mask__home-work"></i>{{ 'VacancyTalentDetails.Workplace' | translate }}
    </div>
    <div>
      <ng-container *ngIf="data.workPlaceMatch.vacancy">
        {{ data.workPlaceMatch.vacancy | workplace }}
      </ng-container>
      <ng-container *ngIf="!data.workPlaceMatch.vacancy">Not specified</ng-container>
    </div>
    <div [class.is-red]="matchRed.workPlaceMatch">
      <ng-container *ngIf="data.workPlaceMatch.talent">
        {{ data.workPlaceMatch.talent | workplace }}
      </ng-container>
      <ng-container *ngIf="!data.workPlaceMatch.talent">Not specified</ng-container>
    </div>
  </div>

</div>